// :: globals
// :: Define all global variables inside this folder

// :: App
export const app = {
  name: process.env.VUE_APP_NAME,
  eventsAppDomain: process.env.VUE_APP_EVENTS_APP_DOMAIN,
  url: process.env.VUE_APP_URL,
  api: {
    stripe: {
      publicKey: process.env.VUE_APP_STRIPE_PUBLIC_KEY,
    },
  },
};

export const appColors = [
  "#0093d6",
  "#ffc400",
  "#5a0dab",
  "#00d2b8",
  "#0093d6",
  "#ffc400",
  "#5a0dab",
  "#00d2b8",
  "#0093d6",
  "#ffc400",
  "#5a0dab",
  "#00d2b8",
  "#0093d6",
  "#ffc400",
  "#5a0dab",
  "#00d2b8",
  "#0093d6",
  "#ffc400",
  "#5a0dab",
  "#00d2b8",
];
